import { CLIO_ACCESS_CODE_SUCESS } from "../actions/types";

const initialState = {};

export default function (state = initialState, action) {
	switch (action.type) {
		case CLIO_ACCESS_CODE_SUCESS:
			return {
				...state,
				clioAccessCodeStatus: action.payload,
			};
		default:
			return state;
	}
}
